import { Injectable } from '@angular/core';
import { TranslationLocalService } from 'gung-standard';
import seTranslations from '../i18n/se.json';
import enTranslations from '../i18n/en.json';
import fiTranslations from '../i18n/fi.json';
import { HttpBackend, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TyloTranslationLocalService extends TranslationLocalService {
  constructor(protected http: HttpClient, handler: HttpBackend) {
    super(http, handler);
  }

  protected async getCustTranslations(lang: string): Promise<any> {
    if (lang === 'se') {
      const coreTranslations = await seTranslations;
      const erpGeneratedTranslations = await this.http.get<any>('i18n/erp-generated/' + lang + '.json').toPromise();
      const res = {
        ...coreTranslations,
        ...erpGeneratedTranslations
      };
      return res;
    }
    if (lang === 'fi') {
      const coreTranslations = await fiTranslations;
      const erpGeneratedTranslations = await this.http.get<any>('i18n/erp-generated/' + lang + '.json').toPromise();
      const res = {
        ...coreTranslations,
        ...erpGeneratedTranslations
      };
      return res;
    }
    if (lang === 'en') {
      const coreTranslations = await enTranslations;
      const erpGeneratedTranslations = await this.http.get<any>('i18n/erp-generated/' + lang + '.json').toPromise();
      const res = {
        ...coreTranslations,
        ...erpGeneratedTranslations
      };
      return res;
    }
    return {};
  }
}
